import * as _ from "lodash";
import React, { useEffect, useReducer, useState } from "react";
import { xyChartTransformation } from "../../../../component/common/XYChart/XYChart.transform";
import XYChart from "../../../../component/common/XYChart/XYChart";
import ZFGroupButton, {
	IButtonElement,
} from "../../../../component/ui-component/ZFGroupButton/ZFGroupButton";
import ZFTabs from "../../../../component/ui-component/ZFTabs/ZFTabs";
import { TIconType } from "../../../../component/component";
import { commonTableTransformation } from "../../../../component/common/CommonTable/CommonTable.transform";
import CommonTable from "../../../../component/common/CommonTable/CommonTable";
import { ChartColors, IXYChartConfig } from "../../../../component/common/XYChart/XYChart.d";
import { ITableConfig } from "../../../../component/common/CommonTable/CommonTable.d";
import { DropDownList } from "../../../../component/common/CommonDropdown/dropdown/DropDown";
import { IDropDownListProps } from "../../../../component/common/CommonDropdown/dropdown/DropDown.d";
import ZFButton from "../../../../component/ui-component/ZFButton/ZFButton";
import { ButtonType } from "../../../../component/ui-component/ZFButton/ZFButton.d";
import ZFIcon from "../../../../component/ui-component/ZFIcon/ZFIcon";
import { ButtonState } from "../../../../component/ui-component/ZFButton/ZFButton.d";
import { TFilterDropDownData } from "../../../../fixtures/data-fixtures/ComponentConfigFixtures";
import { Actions, ITabsComponentState, IComponentActionProps, TActionPayload, IInitTabsComponentPayload,
	ISetFilterPayload, ITabsComponentFilter, ITabsComponentProps, ISubTabUpdatePayload, ITabUpdatePayload,
	IToggleFilterPayload, IDataUpdatePayload, IDetailViewFilterProps, ISyncPayload} from "./TabsComponent.d";
import useClickOutSide from "../../../../utils/custom-hooks/useClickOutside";
import { Loader } from "../../../../component/utility/Loader/Loader";
import { GraphLegends, IGraphLegend } from "../../../../component/common/GraphLegend/GraphLegend";

const reducer = (
	state: ITabsComponentState,
	obj: IComponentActionProps
): ITabsComponentState => {
	const { action } = obj;
	const payload = obj.payload as TActionPayload;
		switch (action) {
			case Actions.INIT_STATE:
				return {
					...state,
					...(payload as IInitTabsComponentPayload).state
				}

			case Actions.TAB_UPDATE:
				return {
					...state,
					activeTabIndex: (payload as ITabUpdatePayload).newTabIndex,
				};

			case Actions.SUBTAB_UPDATE:
				return {
					...state,
					activeSubTabIndex: (payload as ISubTabUpdatePayload).newSubTabIndex
				};

			case Actions.DATA_UPDATE:
				return {
					...state,
					data: (payload as IDataUpdatePayload).data,
				};

			case Actions.SET_SELECTED_FILTER:
				const payload1 = payload as ISetFilterPayload;
				const newFilters = [...state.filters];
				newFilters[payload1.index].displayValue = payload1.displayValue;
				newFilters[payload1.index].config.selected = payload1.selected;
				return { ...state, filters: newFilters };

			case Actions.SET_FILTER:
				const newFilters1 = [...state.filters];
				newFilters1[(payload as IToggleFilterPayload).index] = (payload as IToggleFilterPayload).filter;
				return { ...state, filters: newFilters1 };

			case Actions.SYNC_COMPONENT:
				return { ...state, filters: (payload as ISyncPayload).filters || [], data: (payload as ISyncPayload).data || {} }

			case Actions.CLEAR_ALL_FILTER:
				return { ...state, filters: state.filters.map((f) => {
						return { ...f, config: { ...(f.config), selected: [] } };
					})
				};

			default:
				return state;
		}
};

export const TabsComponent = ({ config, data, filters, syncTime, onFilterChange }: ITabsComponentProps) => {

	const INITIAL_STATE = {
		tabs: [{title: '', subTabs: [{title: '', componentType: 'XY_CHART', iconName: 'chart', componentConfig: {}}]}],
		title: 'TITLE',
		activeTabIndex: 0,
		activeSubTabIndex: 0,
		componentData: {},
		filters: [] as ITabsComponentFilter[],
		activeConfig: {},
		data: {}
	} as ITabsComponentState;

	const componentHeight = "300px";

	const [state, dispatch] = useReducer(reducer, INITIAL_STATE);
	const [loaderState, setLoaderState] = useState(true);

	useEffect(() => {
		if (config) {
			const config1 = _.cloneDeep(config);
			const newState = { ...state };
			newState.title = config1.title || '';
			newState.tabs = config1.tabs || [];
			// newState.filters = filters || [];
			// newState.data = data || {};

			dispatch(
				{
					action: Actions.INIT_STATE,
					payload: { state: newState }
				}
			);

			setLoaderState(false);
		}
		
	}, []);

	useEffect(() => {
		const filters1 = _.cloneDeep(filters);
		const data1 = _.cloneDeep(data);

		dispatch(
			{
				action: Actions.SYNC_COMPONENT,
				payload: { filters: filters1, data: data1 }
			}
		);		
	}, [syncTime]);

	const onTabChange = (newTabIndex: number) => {
		dispatch(
			{
				action: Actions.TAB_UPDATE,
				payload: { newTabIndex } as ITabUpdatePayload
			}
		);

		const newSubTabArray = state.tabs[newTabIndex].subTabs;
		
		if (newSubTabArray.length < state.activeSubTabIndex + 1) {
			dispatch(
				{
					action: Actions.SUBTAB_UPDATE,
					payload: { newSubTabIndex: 0 } as ISubTabUpdatePayload
				}
			);
		}
	};

	const onSubTabChange = (newSubTabIndex: number) => {
		dispatch(
			{
				action: Actions.SUBTAB_UPDATE,
				payload: { newSubTabIndex } as ISubTabUpdatePayload
			}
		);
	};

    const getActiveSubTab = () => {
		const activeTab = state.tabs[state.activeTabIndex];
		return activeTab.subTabs[state.activeSubTabIndex]
    }

	const getActiveComponentType = () => {
		const activeSubTab = getActiveSubTab();
		if (activeSubTab) {
			return activeSubTab.componentType;
		}
    }

	const getActiveSubTabLegendsInfo = () => {
		const activeSubTab = getActiveSubTab();
		if (activeSubTab) {
			const info = _.get(activeSubTab, ['legendsInfo', 'legends'], null) as Array<IGraphLegend>;
			if (info && Array.isArray(info)) {
				return info.map((_) => {
					return { iconColor: ChartColors[_.iconColor], value: _.value };
				})
			}
		}
	}

	const getActiveTab = () => {
        return state.tabs[state.activeTabIndex];
    }

	const fetchData = async (selectedFilters: Array<any>) => {
		setLoaderState(true);
		const data = await onFilterChange(selectedFilters);
		dispatch({
			action: Actions.DATA_UPDATE,
			payload: { data }
		});
		setLoaderState(false);
	}

	const getChartConfig = () => {
		const activeSubTab = getActiveSubTab();
		const activeTab = getActiveTab();

		const tabData = _.get(state.data, activeTab.data_path, state.data);
		const subTabData = _.get(tabData, activeSubTab.data_path, tabData);

		const x=  xyChartTransformation(
			subTabData,
			activeSubTab.componentConfig as IXYChartConfig,
			false,
			componentHeight
		);

		return x;
	};

    const getTableConfig = () => {
        const activeSubTab = getActiveSubTab();
		const activeTab = getActiveTab();

		const tabData = _.get(state.data, activeTab.data_path, state.data);
		const subTabData = _.get(tabData, activeSubTab.data_path, tabData);

		return commonTableTransformation(
			subTabData,
			activeSubTab.componentConfig as ITableConfig,
			componentHeight
		);
	};

	const getGroupButtonProps = (): IButtonElement[] => {
		return state.tabs[state.activeTabIndex].subTabs.map((r) => {
			return {
				title: r.title,
				iconProperties: {
					iconName: r.iconName as TIconType,
					iconClasses: ["zf-icon--size-md", "zf-icon--margin-l-xs"],
				},
			};
		});
	};

	// const changeFilterSelection = (item: TFilterDropDownData, index: number, filter: ITabsComponentFilter) => {
	// 	const newFilterConfig = {...filter.config} as IDropDownListProps;
	// 	const isMultiSelectable = filter.multiSelection;
	// 	let displayValue = filter.displayValue;

	// 	if (isMultiSelectable) {
	// 		if (newFilterConfig.selected.includes(item)) {
	// 			newFilterConfig.selected = newFilterConfig.selected.filter((_) => !(_.dimension === item.dimension && _.value === item.value));
	// 		} else {
	// 			newFilterConfig.selected.push(item);
	// 		}
	// 	} else {
	// 		newFilterConfig.selected = [item];
	// 		displayValue = item.value;
	// 	}

	// 	dispatch(
	// 		{
	// 			action: Actions.SET_SELECTED_FILTER,
	// 			payload: { selected: newFilterConfig.selected, index, displayValue },
	// 		},
	// 	);
	// }

	const removeFilter = (item: TFilterDropDownData, filter: ITabsComponentFilter, index: number) => {
		const newFilterConfig = {...filter.config} as IDropDownListProps;
		let selected = newFilterConfig.selected.filter((_) => !(_ === item));

		const selectedFilters = state.filters.map((f) => {
			if (f.key === filter.key) {
				return { key: f.key, values: selected.map((_) => _.value) };
			} else {
				return { key: f.key, values: f.config.selected.map((_) => _.value) };
			}
		}).filter((_) => _.values.length > 0);

		dispatch(
			{
				action: Actions.SET_SELECTED_FILTER,
				payload: { selected, index, displayValue: filter.displayValue }
			}
		);

		fetchData(selectedFilters);
	}

	const onFilterClose = (i: number, filter: ITabsComponentFilter) => {
		const oldFilter = _.cloneDeep(state.filters[i]);

		if (!_.isEqual(oldFilter.config.selected, filter.config.selected)) {
			const selectedFilters = state.filters.map((f) => {
				if (f.key === filter.key) {
					return { key: f.key, values: filter.config.selected.map((_) => _.value) };
				} else {
					return { key: f.key, values: f.config.selected.map((_) => _.value) };
				}
			}).filter((_) => _.values.length > 0);

			dispatch(
				{
					action: Actions.SET_FILTER,
					payload: { index: i, filter }
				}
			);

			fetchData(selectedFilters);
		}
	}

	const setSearchString = (value: string, index: number, filter: ITabsComponentFilter) => {
		let newFilter = {...filter};
		newFilter = {...newFilter, config: {...newFilter.config, searchString: value } };
		dispatch(
			{
				action: Actions.SET_FILTER,
				payload: { index, filter: newFilter }
			}
		);
	}

	const isClearAllRequired = (state: ITabsComponentState) => {
		return state.filters.some((_) => _.config.selected.length > 0);
	}

	const clearAllFilter = () => {
		dispatch(
			{
				action: Actions.CLEAR_ALL_FILTER,
				payload: {}
			}
		);

		fetchData([]);
	}

	return (
		<div className="tabs-component-card zf-padding-xl">
			<>
				{
					(loaderState) && <div className="loader comp-loader"><Loader size={"L_MEDIUM"}/></div>
				}
				{
					(!loaderState) && (
						<>
						<div className="header">{state.title}</div>
						{
							(state.filters && state.filters.length > 0) && (
								<div style={{marginBottom: 24}}>
									<div style={{display: 'flex'}}>
									{
										state.filters.map((filter, i) => {
											return (
												<DetailViewFilter filter={filter} key={`detail_view_filter_${filter.key}`}
												onFilterClose={(filter) => onFilterClose(i, filter)}/>
											)
										})
									}
									</div>
									{
										state.filters.filter((_) => _.multiSelection).map((filter, i) => {
											return (
												<div className="chips-btn-row zf-margin-r-xxl-s" key={`detail_view_filter_chip_${filter.key}`}>
													{
														filter.config.selected.map((selectedFilter: TFilterDropDownData) => {
															return (
																<div key={`detail_view_selected_filter_${selectedFilter.value}`} 
																	className="zf-margin-t-xxl-s secondary-chips-btn zf-margin-r-xxl-s zf-margin-b-xxl-s zf-padding-l-s zf-padding-r-s zf-padding-t-xs zf-padding-b-xs zf-text-font-size-s zf-text-color-black-80 zf-text-font-weight-medium">
																	<div>{selectedFilter.value}</div>
																	<div className="zf-margin-l-xxl-8 zf-icon-react--size-l" onClick={() => removeFilter(selectedFilter, filter, i)}><ZFIcon iconName={'cross'} iconClasses={['zf-icon-react--size-l']}/></div>
																</div>
															)
														})
													}
													{
														isClearAllRequired(state) && <div onClick={() => clearAllFilter()} 
														className="clear-all zf-margin-t-xxl-s zf-margin-r-xxl-s zf-margin-b-xxl-s zf-padding-l-s zf-padding-r-s zf-padding-t-xs zf-padding-b-xs zf-text-font-size-s zf-text-color-black-80 zf-text-font-weight-medium">Clear All</div>
													}
												</div>
											)
										})
									}
								</div>
							)
						}
						{
							(state.tabs.length > 0) && (
								<>
									<ZFTabs
										activeTabIndex={state.activeTabIndex}
										onTabChange={onTabChange}
										tabs={state.tabs.map((t) => {
											return { title: t.title };
										})}
									/>
									<div className="sub-tab-row">
										<div style={{width: '75%'}}>
											{
												(getActiveSubTab() && getActiveSubTab().header) && (
													<span>{getActiveSubTab().header}</span>
												)
											}
										</div>     
										{
											(getGroupButtonProps().length > 1) && (
												<div style={{width: '25%', display: 'flex', justifyContent: 'flex-end'}}>
													<ZFGroupButton
														buttons={getGroupButtonProps()}
														onGroupBtnClick={onSubTabChange}
														activeIndex={state.activeSubTabIndex}
													/>
												</div>
											)
										}
									</div>
									<div style={{minHeight: 300}}>
									{
										(getActiveComponentType() === 'XY_CHART') && (
											<>
												{
													(getActiveSubTabLegendsInfo()) && (
														<div style={{marginTop: 16, marginBottom: 16}}>
															<GraphLegends legends={getActiveSubTabLegendsInfo()}/>
														</div>
													)
												}
												<XYChart
													key={`chart_${state.activeTabIndex}_${state.activeSubTabIndex}`}
													config={getChartConfig()}
												/>
											</>
										)
									}
									{
										(getActiveComponentType() === 'TABLE') && (
											<div style={{marginTop: 12}}><CommonTable config={getTableConfig()}/></div>
										)
									}
									</div>
								</>
							)
						}
						</>
					)
				}
			</>
		</div>
	);
};



const DetailViewFilter = ({ filter, onFilterClose }: IDetailViewFilterProps) => {

	const [filterState, updateFilterState] = useState(_.cloneDeep(filter));
	const [openState, setOpenState] = useState(false);

	const changeFilterSelection = (item: TFilterDropDownData) => {
		const newFilterConfig = {...filterState.config} as IDropDownListProps;
		const isMultiSelectable = filterState.multiSelection;
		let displayValue = filterState.displayValue;

		if (isMultiSelectable) {
			if (newFilterConfig.selected.includes(item)) {
				newFilterConfig.selected = newFilterConfig.selected.filter((_) => !(_.dimension === item.dimension && _.value === item.value));
			} else {
				newFilterConfig.selected.push(item);
			}
		} else {
			newFilterConfig.selected = [item];
			displayValue = item.value;
		}

		updateFilterState({...filterState, displayValue, config: newFilterConfig });
	}

	const setSearchString = (value: string) => {
		let newFilter = {...filterState};
		newFilter = {...newFilter, config: {...newFilter.config, searchString: value } };
		updateFilterState(newFilter);
	}

	const closeFilter = () => {
		if (openState) {
			toggleFilterState(false);
		}
	}

	const toggleFilterState = (state: boolean) => {
		setOpenState(state);
		if (!state) {
			onFilterClose(_.cloneDeep(filterState));
		}
	}

	const ref = useClickOutSide(closeFilter);

	return (
		<div key={`filter-btn-${filterState.key}`} ref={ref} style={{position: "relative"}}>
			<ZFButton
				onBtnClick={() => toggleFilterState(!openState)}
				buttonType={ButtonType.secondary}
				state={
					filterState.config.filters.length > 0
						? ButtonState.default
						: ButtonState.disabled
				}
				buttonClasses={[
					"zf-text-medium zf-padding-l-s zf-padding-r-s zf-padding-t-xs zf-padding-b-xs zf-margin-r-xxl-s",
				]}
			>{filterState.displayValue}
			<ZFIcon
				iconName="collapse"
				iconClasses={[
					"zf-icon-react--size-md zf-icon-react--bg-center zf-margin-l-xxl-8",
				]}
			/>
			</ZFButton>
			{
				(openState) && (
					<div className="dd-list">
						<div className="dd-search-container">
							{true && (
								<div className="dd-search zf-padding-l-s zf-padding-r-s zf-padding-t-xxs zf-padding-b-xxs">
									<input
										className="search-input"
										placeholder={
											'Search'
										}
										onChange={(event) =>
											setSearchString(event.target.value)
										}
										value={filterState.config.searchString}
									/>
									<ZFIcon
										iconName="search"
										iconClasses={["zf-icon-react--size-s"]}
									/>
									</div>
							)}
						</div>
						<DropDownList filters={filterState.config.filters} header={filterState.config.header}
							onFilterChange={(item: TFilterDropDownData) => changeFilterSelection(item)}
							searchString={filterState.config.searchString} selected={filterState.config.selected}/>
					</div>
				)
			}
		</div>
	)
}

